import type { TaskT, TaskDataT } from 'pages/Tasks/types'
import { taskTypes } from 'shared/constants'
import type { AuthPersonIdAndPermissions } from 'types'

export const getPersonId = (persons: AuthPersonIdAndPermissions[] | undefined, task: TaskT<TaskDataT>) => {
  if (!persons) return undefined

  switch (task.taskType) {
    case taskTypes.absenceRequest:
      return persons.find((person) => task.person && `${person.id}` === `${task.person.id}`)?.id
    case taskTypes.shareUserData:
      return persons.find((person) => person.permissions.workflowShareUserData)?.id
    case taskTypes.secureConnection:
      return persons.find((person) => person.permissions.workflowSecureConnection)?.id
    default:
      return persons.find((person) => person.permissions.workflowMonthlySheets)?.id
  }
}
